var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"48,7 48,7 48,7 46.5,5.6 46.5,5.6 40.9,0 39.5,1.4 44.1,6 0,6 0,8 44.1,8 39.5,12.7 40.9,14.1 \n\t46.5,8.5 46.5,8.5 "}));
}

Arrow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 48 14.1","style":{"enableBackground":"new 0 0 48 14.1"},"xmlSpace":"preserve"};

module.exports = Arrow;

Arrow.default = Arrow;
